import { defineMessages } from 'react-intl';

export default defineMessages({
    caDetailsCollision: {
        id: 'fnol.ca.views.ca-theft-details.Details (Theft)',
        defaultMessage: 'Details (Theft)'
    },
    caWhatHappened: {
        id: 'fnol.ca.views.ca-theft-details.What Happened?',
        defaultMessage: 'Please describe what happened'
    },
    caDescribeWhatHappened: {
        id: 'fnol.ca.views.ca-theft-details.Describe what happened',
        defaultMessage: 'Describe what happened'
    },
    caVechilesInvolved: {
        id: 'fnol.ca.views.ca-theft-details.Which vehicle was involved?',
        defaultMessage: 'Which vehicle was involved?'
    },
    caTheftChooseVehicle: {
        id: 'fnol.ca.views.ca-theft-details.Choose Vehicle',
        defaultMessage: '-- Choose Vehicle --'
    },
    caWhatStolen: {
        id: 'fnol.ca.views.ca-theft-details.What was stolen?',
        defaultMessage: 'What was stolen?'
    },
    caEntireVehicle: {
        id: 'fnol.ca.views.ca-theft-details.The entire vehicle',
        defaultMessage: 'The entire vehicle'
    },
    caOtherVehiclecarts: {
        id: 'fnol.ca.views.ca-theft-details.Audio or other equipment on or in the vehicle',
        defaultMessage: 'Audio or other equipment on or in the vehicle'
    },
    caAdditionalInformationVehicle: {
        id: 'fnol.ca.views.ca-theft-details.Any additional information about the theft?',
        defaultMessage: 'Any additional information about the theft?'
    },
    caTheftWhereDidThisHappenPropertyDamage: {
        id: 'fnol.ca.views.ca-theft-loss-details.Where did this happen?',
        defaultMessage: 'Where did this happen?'
    }
});
